module.exports = __webpack_public_path__ + "static/media/program-8.36b33e23.webp";